export enum AcademicType {
    none = 0,
    stage = 1,
    class = 2,
    section = 3,
    subject = 4,
    All = 5,
}